import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { Dialog, DialogPortal, DialogOverlay, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import { useLang } from "@/i18n";
import { HOME_COPY as C } from "@/data/homeContent";

export const HomeDialog = ({ open, onOpenChange, title, description, children, id, className = "", onCloseAutoFocus }) => {
  const { t } = useLang();
  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogPortal>
      <DialogOverlay className="rh-dialog-overlay" data-testid={`${id}-overlay`} />
      <DialogPrimitive.Content className={`ritual-editorial rh-dialog ${className}`} data-testid={id} onCloseAutoFocus={onCloseAutoFocus}>
        <div className="rh-dialog-heading">
          <DialogTitle className="rh-dialog-title" data-testid={`${id}-title`}>{title}</DialogTitle>
          <DialogDescription className="sr-only" data-testid={`${id}-description`}>{description}</DialogDescription>
          <DialogClose asChild><button className="rh-icon-button" aria-label={t(C.close)} data-testid={`${id}-close`}><X size={23} strokeWidth={1.3} /></button></DialogClose>
        </div>
        {children}
      </DialogPrimitive.Content>
    </DialogPortal>
  </Dialog>;
};